<h1 mat-dialog-title>DELETE SONG</h1>
<div mat-dialog-content>
  <p>You cannot undo this action. Would you continue?</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="modalRemoveSongCancel()">CANCEL</button>
  <button mat-button (click)="removeSong(song)" cdkFocusInitial>YES</button>
</div>